import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import type { SkeletonProps } from './Skeleton.types';

export const Skeleton: FC<SkeletonProps> = ({ height, width, className, ...rest }) => (
	<span
		className={twMerge('block animate-pulse rounded bg-gray-200', className)}
		style={{ height, width }}
		{...rest}
	/>
);
